import { computed } from 'vue-demi';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');

export default (tpl) => {
    // css变量
    const cssPropertys = computed(() => {
        return {
            '--tab-header-width': rem.str(tpl.props.headerWidth),
            '--tab-header-padding': rem.str(tpl.props.headerSpacing / 4),
            '--tab-header-margin': rem.str(tpl.props.headerSpacing / 4),
            '--tab-header-font-size': rem.str(tpl.props.headerFontSize),
            '--tab-header-color-famliy': tpl.props.headerFontFamily,
            '--tab-line-color': tpl.props.lineColor,
            '--tab-header-color': tpl.props.headerFontColor,
            '--tab-header-active-color': tpl.props.headerActiveColor,
            '--tab-header-active-bar-color': tpl.props.headerBarColor,
            '--tab-header-align': tpl.props.headerJustifyContent,
            '--tab-active-bar-top': rem.str(tpl.props.headerSpacing / 4),
            '--tab-body-height': rem.str(tpl.style.height),
        };
    });
    return {
        cssPropertys
    };
};
